import Image from 'app/Components/Shared/Image/image';
import React, { useEffect,useState } from 'react';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';
import { gtag4 } from '../../../../../utilities/analytics/tracking'
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import iconMinusDisabled from './images/icon-minus-disabled.svg';
import iconPlusDisabled from './images/icon-plus-disabled.svg';
import iconLoading from './images/icon-loading.svg';
import iconMinus from './images/icon-minus.svg';
import iconPlus from './images/icon-plus.svg';
export const Addons = (props) => {
  const {
    addons,
    handleUpdateAddons,
    reportDWH,
    saleType,
    flowType,
    isLoadingShoppingCart,
    selectedAddOns,
    updateStore
  } = props;

  const [isDisplayPopup, setIsDisplayPopup] = useState(false);
  const [detailsPopUp,setDetailsPopUp] = useState({
    image: '',
    title: '',
    text: '',
    link: '',
    textLink: ''
  });

  const [addonSelections, setAddonSelections] = useState([]);

  const funnel_name = (flowType === 'newCustomer') ? '_New' : '_Exists';

  useEffect(() => {
    gtag4({
      'event' : `${saleType}_Step5_AddonsPage`,
      'step': '5',
      'action': 'AddonsPage',
      'funnel_name': `${saleType}_Exists${funnel_name}_Customer`,
    });
  },[]);

  useEffect(() => {
    if(selectedAddOns){
      let initialAddonSelections = addons.map((addon) => {
        const matchingSelectedAddon = selectedAddOns?.find((selectedAddon) => selectedAddon.name === addon.name);
        return matchingSelectedAddon?.count === 1;
      });

      setAddonSelections(initialAddonSelections);
    }
  }, [selectedAddOns]);

  const equipment = addons.find(x => x.isEquipment === true);

  const Price = (props) => {
    const addons = props.addonsList;
    const hasMeshAddons = addons.some(addon => ['MESH', 'MESHUL', 'MESHPR'].includes(addon.name));
    const totalPrice = addons.reduce((total, addon) => total + parseFloat(addon.price), 0);

    return (
      <>
        <div className="price">₪{hasMeshAddons && addons.length > 1 ? totalPrice.toFixed(2) : addons[0].price}</div>
        {props.deletePrice === null && <div className="period-time">לחודש</div>}
      </>
    );
  };

  const handleClosePopup = ()=> {
    setIsDisplayPopup(false);
  };

  const handleOpenPopup = (item)=> {
    const dataCms = item.addonsList[0].cmsData;
    setDetailsPopUp({
      ...detailsPopUp,
      image:dataCms.imagePopUp,
      title:dataCms.titlePopUp,
      text:dataCms.textPopUp,
      link:dataCms.linkRegulations,
      textLink: dataCms.textLinkPopUp
    });
    setIsDisplayPopup(true);
    let actionType = 'AddOns';
    if(saleType == 'cellular'){
      actionType = 'Setting Line';
    }
    reportDWH({ actionType: actionType , status: 'Ongoing', messageText: 'More Info AddOns Clicked' });
    gtag4({
      event : `${saleType}_Step5_MeshButton`,
      step: '5',
      button:'לפרטים נוספים',
      action: 'MeshButton',
      funnel_name: `${saleType}_Exists${funnel_name}_Customer`,
    });
  };


  function getAddonsCount (addons){
    if (!Array.isArray(addons)) {
      addons = [addons];
    };
    let count = addons.filter((x) => x.action == 'Add').length;
    return count;
  };

  // Realization of plus and minus in a Equipment component
  function isDisplayAdd(addonsList) {
    const addons = addonsList?.filter((x) => x.action == 'Add');
    if(addons.length < 1) {
      return false;
    };
    const upperLimit = addonsList[0].upperLimit;
    return addons.length < upperLimit;
  };

  function isDisplayRemove(addonsList) {
    const addons = addonsList?.filter((x) => x.action == 'Add');
    const lowerLimit = addonsList[0].lowerLimit;
    return addons.length - 1 > lowerLimit;
  };

  const handleAddAddon = (i,name,addons)=> {
    const count = getAddonsCount(addons);
    let data = {
      name: name,
      count: count + 1,
    };
    handleUpdateAddons(data);
  };

  const handleRemoveAddon = (name,addons)=> {
    const count = getAddonsCount(addons);

    if (count == 1) { return; };

    let data = {
        name: name,
        count: count > 1 ? count - 1 : 1,
    };
    handleUpdateAddons(data);
  };

  const handleAddonCheckboxChange = (index, name, addonsList) => {
    const checkBoolean = [...addonSelections];
    checkBoolean[index] = !checkBoolean[index];
    setAddonSelections(checkBoolean);
    let data;
    if(checkBoolean[index]  === true) {
      const count = getAddonsCount(addonsList);
      data = {
      name: name,
      count: count > 1 ? count : 1,
    };
    }else {
      data = {
      name: name,
      count: 0,
      };
    };
    if(updateStore){
      updateStore(data);
    }
    if(handleUpdateAddons){
      handleUpdateAddons(data);
    }
  };

  const tieredPrice = (item) => {
    const month = ['הראשון', 'השני', 'השלישי', 'הרביעי', 'החמישי', 'השישי', 'השביעי', 'השמיני', 'התשיעי', 'העשירי'];
    const objForAmount = item.find((item) => (item.from === 0 || item.to === 0) && item.amount !== 0);
    const objForPrice = item.find((item) => (item.from !== 0));

    if (objForAmount) {
      const { amount } = objForAmount;
      const { price } = objForPrice;
      const monthName = month[Number(amount)];
      return (
        <div className="tiered-price">
          חיוב לחודש הראשון
          <div>
            חיוב חודשי החל מהחודש {monthName} <span>₪{price}</span>
          </div>
        </div>
      );
    };
  };

  function displayDeletePrice(item) {
    if (!item) {
      return null;
    };
    if(item.length > 0){
      item = item[0];
    };
    const isDisplayDelete = parseFloat(item?.price) < parseFloat(item?.originalPrice);
    if(isDisplayDelete){
      return (
        <div className='short-description'>מחיר לחודש במקום
          <del> ₪{item?.originalPrice} </del>לחודש
        </div>
      );
    }else if (item.priceItemList.length > 1) {
      return !null
    } else {
      return null;
    };
  };

  return (
    <div className='addons-wrapper'>
      {addons?.map((item,i)=>{
        const hasLowerLimit = item.addonsList.some((x)=> x.lowerLimit != 0);
        const isMandatory = item.addonsList.some((x) => x.defaultNumber != 0 && hasLowerLimit);
        const isSelected = addonSelections[i] ;
        const uniqueNamesSet = new Set();
        const priceDescription = item.addonsList.map((addonItem) => {
          if (uniqueNamesSet.has(addonItem.name)) return '';
          uniqueNamesSet.add(addonItem.name); // Add the name to the set
          return addonItem.priceItemList.length >= 2 ? tieredPrice(addonItem.priceItemList) : displayDeletePrice(addonItem);
        });
        return (
          <div key={i}>
            <div className=
            {`addons-item
              ${isSelected === true ? 'border-another-color' : ''}
              ${item.addonsList[0].cmsData?.promotionTag.length > 1 ? 'big-padding' : ''}
            `}>
              <div className='header-box'>
                <div className='title-wrapper'>
                  <div>
                    <CheckBox
                      checked={isSelected}
                      label={item.addonsList[0].cmsData?.productName}
                      id={item.addonsList[0].name}
                      onChange={() => isMandatory ? null : handleAddonCheckboxChange(i,item.name, item.addonsList)}
                    >
                    </CheckBox>
                  </div>
                </div>
                <div className='price-wrapper'>
                  <Price addonsList={item.addonsList} deletePrice={displayDeletePrice(item.addonsList)}/>
                </div>
              </div>
              {item.addonsList[0].cmsData?.promotionTag && <div className='tag' dangerouslySetInnerHTML={{ __html: item.addonsList[0].cmsData?.promotionTag }}></div>}
              {priceDescription}
              <div className='details-wrapper'>
                {item.addonsList[0].cmsData?.descriptionProduct  &&<div dangerouslySetInnerHTML={{ __html: item.addonsList[0].cmsData?.descriptionProduct }}></div>}
                {item.addonsList[0].cmsData?.textLink && <a className='details' href='#' onClick={() => handleOpenPopup(item)}>לפרטים נוספים</a>}
                {item.isEquipment === true &&
                  <div className='equipment'>
                  <hr className='addons-hr'></hr>
                  <h2>כמה יחידות אתה צריך?</h2>
                <div className='equipment-buttons'>
                  {
                      isDisplayRemove(equipment.addonsList) ? (
                          <button className='btn-remove' onClick={() => handleRemoveAddon(equipment.name, equipment.addonsList, i)} style={{backgroundImage:iconMinus.bg()}}></button>
                      ) : (
                          <div className='btn-remove disabled' style={{backgroundImage:iconMinusDisabled.bg()}}></div>
                      )
                  }
                  <div className='count'>{getAddonsCount(equipment.addonsList)} </div>
                  {
                      isDisplayAdd(equipment.addonsList) ? (
                          <button className='btn-add' onClick={() => handleAddAddon(i,equipment.name, equipment.addonsList)} style={{backgroundImage:iconPlus.bg()}}></button>
                      ) : (
                          <div className='btn-add disabled' style={{backgroundImage:iconPlusDisabled.bg()}}></div>
                      )
                  }
                </div>
                  {equipment.addonsList.filter((x) => x.action == 'Add').map((item, i) => {
                    return (
                      <div className='equipment-status' key={i}>
                        <div className='name-wapper'>Mesh {i+1}</div>
                        <div className='price'>
                            ₪{item.price}
                            <div className='text-of-price'> לחודש </div>
                        </div>
                      </div>
                    )
                  })}
                {isLoadingShoppingCart && (
                      <div className="loader">
                        <Image src={iconLoading} alt="Loading..." className="loader-icon" />
                      </div>
                    )}
                  </div>
                }
              </div>
            </div>
          </div>
        )
      })}
      <PopUp
            showPopUp={isDisplayPopup}
            onClose={() => setIsDisplayPopup(false)}
            footerBtn={{ text: 'חזרה', onBtnClick: handleClosePopup }}
          >
          <div className='card-popup'>
            {detailsPopUp.image &&<Image src={Config.epiBaseUrl + detailsPopUp.image} alt="image" />}
            {detailsPopUp.title &&<h1 dangerouslySetInnerHTML={{ __html: detailsPopUp.title }}></h1>}
            {detailsPopUp.text && <div className='text-popup' dangerouslySetInnerHTML={{ __html: detailsPopUp.text }}></div>}
            {detailsPopUp.link && <a href='#' onClick={(e)=> {e.preventDefault(); buildUrlAndOpenWindow(detailsPopUp.link)}}>{detailsPopUp.textLink}</a>}
          </div>
      </PopUp>
    </div>
  )
};
